// extracted by mini-css-extract-plugin
module.exports = {"avatars":"avatars__lYaj+","avatar":"avatar__BNRWs"};